export default __webpack_public_path__ + "rounded-black-square-shape.png";